import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../components/ui/PageHeader';
import { CallListView } from '../components/receiving/CallListView';
import apiClient from '../api/client';

/** The counter's call list: the shortages of the day's close, and the customers' decisions. */
export default function CallListPage() {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  useEffect(() => {
    apiClient
      .get<{ data: { fullName: string | null; email: string } }>('/me/profile')
      .then(({ data }) => setName(data.data.fullName || data.data.email))
      .catch(() => undefined);
  }, []);
  return (
    <div>
      <PageHeader title={t('rcv.calls.pageTitle')} description={t('rcv.calls.pageSubtitle')} />
      <CallListView meName={name} />
    </div>
  );
}
